import { useEffect } from "react";

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy — Sutranode";
  }, []);

  return (
    <section className="section legal-section">
      <div className="container legal-container">
        <div className="s-eyebrow">Privacy</div>
        <h1 className="s-title">Privacy Policy</h1>
        <p className="legal-updated">Last updated: 5 May 2026</p>
        <div className="legal-body" style={{ marginTop: 24 }}>
          <h2>1. Who we are</h2>
          <p>
            Sutranode is a digital growth studio based in India. This policy explains what information
            we collect when you visit sutranode.in or work with us, why we collect it, and how we
            handle it.
          </p>

          <h2>2. What we collect</h2>
          <p>
            <strong>Information you give us.</strong> When you fill out a contact form or message us
            on WhatsApp/email, we receive the details you share — typically name, email, business
            name, website, and what you'd like help with.
          </p>
          <p>
            <strong>Automatic information.</strong> Like most websites, we use Google Analytics to
            understand which pages people visit and how the site is performing. This data is
            aggregated and doesn't personally identify you.
          </p>

          <h2>3. How we use it</h2>
          <p>To reply to your enquiry, send proposals, deliver project work, send invoices, and
          occasionally share useful updates about what we're working on. We don't sell or rent your
          information to anyone.</p>

          <h2>4. Tools we use</h2>
          <p>
            We use a small set of trusted third-party tools — Google Analytics, Google Workspace,
            WhatsApp, and standard email providers — that have their own privacy policies you can
            review on their websites.
          </p>

          <h2>5. Your rights</h2>
          <p>
            You can ask us at any time to share what we hold about you, correct it, or delete it.
            Email <strong>hello@sutranode.in</strong> and we'll handle it within a reasonable time.
          </p>

          <h2>6. Cookies</h2>
          <p>
            Our website uses essential cookies to function and analytics cookies (via Google
            Analytics) to understand site usage. You can disable cookies in your browser if you'd
            prefer not to have them.
          </p>

          <h2>7. Changes to this policy</h2>
          <p>
            We'll update this page if our practices change. The "last updated" date at the top will
            reflect the most recent version.
          </p>

          <h2>8. Contact</h2>
          <p>Questions about this policy? Email <strong>hello@sutranode.in</strong> or message us on WhatsApp at +91 9108181932.</p>
        </div>
      </div>
    </section>
  );
}
